import {
  openChat,
  setGreeting,
} from '@pcf-engineering/gatsby-plugin-pcs-ada-chatbot';

/**
 * Opens the chat widget.
 * @param {string} greeting - open the chat widget with a specific greeting (answer ID in ADA)
 */
const openChatWidget = async (e?, greeting?: string) => {
  if (e) e.preventDefault();

  try {
    if (typeof greeting === 'string' && greeting.match(/^([\w\d])+$/i)) await setGreeting(greeting);
  } catch (err) {
    console.warn(`ADA Answer ID not found: ${greeting}`);
  }

  try {
    openChat();
  } catch (err) {
    console.warn(`Error opening chat window: ${err}`);
  }
};

export default openChatWidget;
